import { createContext } from "../../utils/createContext.mjs";
const [useLazyMotionContext, lazyMotionContextProvider] = createContext("LazyMotionContext");
export {
  lazyMotionContextProvider,
  useLazyMotionContext
};
